import { createContext, useContext } from 'react';
import type { AppError, ToastOptions } from '@/types/errors';

export interface ErrorContextValue {
  /** Current list of active errors/toasts */
  errors: AppError[];
  /** Show an error toast (default severity: 'error') */
  showError: (message: string, options?: ToastOptions) => string;
  /** Show a toast notification (default severity: 'info') */
  showToast: (message: string, options?: ToastOptions) => string;
  /** Dismiss a specific error by ID */
  dismissError: (id: string) => void;
  /** Clear all errors */
  clearAllErrors: () => void;
}

export const ErrorContext = createContext<ErrorContextValue | null>(null);

export function useErrorContext(): ErrorContextValue {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useErrorContext must be used within an ErrorProvider');
  }
  return context;
}
